import axios from 'axios';
import CONFIG, { jnzAuthConfig } from '@root/config/config.next';

export let headers_media = {
  Authorization: jnzAuthConfig?.headersMedia
};

export let headers = {
  'Content-Language': 'th',
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'x-api-key': CONFIG.xApiKey,
  'x-company': jnzAuthConfig?.jnzCompanyToken,
  'x-web-token': jnzAuthConfig?.jnzWebXToken,
};

const timeout = 30000;
const isClient = typeof window !== 'undefined';

const method_GET = async ({ url, params, token, admin_token, }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  await checkJNZAuthHeder();

  const request = axios({
    url: url,
    method: 'GET',
    headers: headers,
    params: params,
    timeout: timeout,
    dataType: 'json',
  });

  return await request
    .then((response) => {
      // console.log("[API] GET : ", response);
      return successHandler(response);
      // dispatch(Authentication_Success(response.data.result));
    })
    .catch((error) => {
      console.error('[API] GET Failure', errorHandler(error));

      console.error('[API] GET Failure', { ...error });

      claerJNZAuthExpiredToken(errorHandler(error));

      return errorHandler(error);
    });

};

const method_GET_GEO = async ({ url, params, token, admin_token, header }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;
  if (header)
    header = { ...headers, ...header }

  await checkJNZAuthHeder();

  const request = axios({
    url: url,
    method: 'GET',
    headers: header,
    params: params,
    timeout: timeout,
    dataType: 'json',
  });

  return await request
    .then((response) => {
      // console.log("[API] GET : ", response);
      return successHandler(response);
      // dispatch(Authentication_Success(response.data.result));
    })
    .catch((error) => {
      console.error('[API] GET Failure', errorHandler(error));

      console.error('[API] GET Failure', { ...error });

      claerJNZAuthExpiredToken(errorHandler(error));

      return errorHandler(error);
    });

};

const method_POST = async ({ url, data, params, token, admin_token, upload = false }) => {

  if (token)
    headers['x-auth-signature'] = token;
  else
    delete headers['x-auth-signature'];

  if (admin_token)
    headers['x-auth-signature'] = admin_token;
  else
    delete headers['x-auth-admin-signature'];

  if (upload)
    headers['Content-Type'] = 'multipart/form-data';

  await checkJNZAuthHeder();

  // console.log("[API] POST : ", data, url);

  const request = axios({
    url: url,
    method: 'POST',
    headers: headers,
    data: data,
    params: params,
    timeout: timeout,
    dataType: 'json',
  });

  return await request
    .then((response) => {
      // console.log("[API] POST : ", { response });
      return successHandler(response);
    })
    .catch((error) => {
      console.error('[API] POST Failure', { error });

      claerJNZAuthExpiredToken(errorHandler(error));
      return errorHandler(error);
    });
};

const method_GET_MULTIPLE_HEADER = async ({ url, data, params, token, admin_token, xApiKey, upload = false }) => {

  if (token)
    headers['x-auth-signature'] = token;
  else
    delete headers['x-auth-signature'];

  if (admin_token)
    headers['x-auth-signature'] = admin_token;
  else
    delete headers['x-auth-admin-signature'];

  await checkJNZAuthHeder();

  // console.log("[API] POST : ", data, url);

  const request = axios({
    url: url,
    method: 'GET',
    headers: Boolean(xApiKey) ? { ...headers, 'x-api-key': xApiKey } : headers,
    params: params,
    timeout: timeout,
    dataType: 'json',
  });

  return await request
    .then((response) => {
      // console.log("[API] GET : ", response);
      return successHandler(response);
      // dispatch(Authentication_Success(response.data.result));
    })
    .catch((error) => {
      console.error('[API] GET Failure', errorHandler(error));

      console.error('[API] GET Failure', { ...error });

      claerJNZAuthExpiredToken(errorHandler(error));

      return errorHandler(error);
    });
};

const method_POST_MULTIPLE_HEADER = async ({ url, data, params, token, admin_token, xApiKey, upload = false }) => {

  if (token)
    headers['x-auth-signature'] = token;
  else
    delete headers['x-auth-signature'];

  if (admin_token)
    headers['x-auth-signature'] = admin_token;
  else
    delete headers['x-auth-admin-signature'];

  if (upload)
    headers['Content-Type'] = 'multipart/form-data';

  await checkJNZAuthHeder();

  // console.log("[API] POST : ", data, url);

  const request = axios({
    url: url,
    method: 'POST',
    headers: Boolean(xApiKey) ? { ...headers, 'x-api-key': xApiKey } : headers,
    data: data,
    params: params,
    timeout: timeout,
    dataType: 'json',
  });

  return await request
    .then((response) => {

      // console.log("[API] POST : ", { response });
      return successHandler(response);
    })
    .catch((error) => {

      console.error('[API] POST Failure', { error });

      claerJNZAuthExpiredToken(errorHandler(error));
      return errorHandler(error);
    });
};

const method_PUT = async ({ url, data, token, admin_token }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  await checkJNZAuthHeder();

  /*console.log('put : ', url, ' : ', data)*/

  const request = axios({
    url: url,
    method: 'PUT',
    headers: headers,
    data: data,
    timeout: timeout,
    dataType: 'json',
  });

  return await request
    .then((response) => {
      /*console.log("[API] PUT : ", response);*/
      return successHandler(response);
      // dispatch(Authentication_Success(response.data.result));
    })
    .catch((error) => {
      console.error('[API] PUT Failure', error);

      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_PATCH = async ({ url, data, token, admin_token }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  await checkJNZAuthHeder();

  /*console.log('put : ', url, ' : ', data)*/

  const request = axios({
    url: url,
    method: 'PATCH',
    headers: headers,
    data: data,
    timeout: timeout,
    dataType: 'json',
  });

  return await request
    .then((response) => {
      /*console.log("[API] PATCH : ", response);*/
      return successHandler(response);
      // dispatch(Authentication_Success(response.data.result));
    })
    .catch((error) => {
      console.error('[API] PATCH Failure', error);

      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_DELETE = async ({ url, data, token, admin_token }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  await checkJNZAuthHeder();

  let config = {
    url: url,
    method: 'DELETE',
    headers: headers,
    timeout: timeout,
    dataType: 'json',
  };

  if (Boolean(data))
    config['data'] = data;

  let request = axios(config);

  return await request
    .then((response) => {
      /*console.log("[API] DELETE : ", response);*/
      return successHandler(response);
      // dispatch(Authentication_Success(response.data.result));
    })
    .catch((error) => {
      console.error('[API] DELETE Failure', error);

      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_MULTIPLE_DELETE = async ({ url, data, array, token, admin_token }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  await checkJNZAuthHeder();

  const multiDeleteFunction = new Promise((resolve, reject) => {
    array.forEach((element) => {
      const request = axios({
        url: `${url}/${element.uuid}`,
        method: 'DELETE',
        headers: headers,
        timeout: timeout,
        dataType: 'json',
      });
      request
        .then((response) => {
          /*console.log("[API] DELETE : ", response, "id", element);*/
        })
        .catch((error) => {
          console.error('[API] DELETE Failure', error);
          reject(error);
        });
    }, resolve());
  });

  return multiDeleteFunction
    .then(() => {
      return 'success';
    })
    .catch((error) => {
      console.log('[API] DELETE Failure', error);

      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_MULTIPLE_PATCH = async ({ url, data, array, token, admin_token }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  await checkJNZAuthHeder();

  const multiDeleteFunction = new Promise((resolve, reject) => {
    array.forEach((element) => {
      const request = axios({
        url: `${url}/${element.uuid}`,
        method: 'PATCH',
        headers: headers,
        data: data,
        timeout: timeout,
        dataType: 'json',
      });
      request
        .then((response) => {
          /*console.log("[API] PATCH : ", response, "id", element);*/
        })
        .catch((error) => {
          console.error('[API] PATCH Failure', error);
          reject(error);
        });
    }, resolve());
  });

  return multiDeleteFunction
    .then(() => {
      return 'success';
    })
    .catch((error) => {
      console.error('[API] DELETE Failure', error);

      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_MULTIPLE_PUT = async ({ url, data, array, token, admin_token }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  await checkJNZAuthHeder();

  const multiDeleteFunction = new Promise((resolve, reject) => {
    array.forEach((element) => {
      data.name = element.name;
      data.code = element.code;
      const request = axios({
        url: `${url}/${element.uuid}`,
        method: 'PUT',
        headers: headers,
        data: data,
        timeout: timeout,
        dataType: 'json',
      });
      request
        .then((response) => {
          /*console.log("[API] PUT : ", response, "id", element);*/
        })
        .catch((error) => {
          console.error('[API] PUT Failure', error);
          reject(error);
        });
    }, resolve());
  });

  return multiDeleteFunction
    .then(() => {
      return 'success';
    })
    .catch((error) => {
      console.error('[API] DELETE Failure', error);

      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_MULTIPLE_EDIT_CART = async ({ url, array, token, admin_token }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  if (isClient && !Boolean(headers['Authorization'])) {
    headers['Authorization'] = `Bearer ${window['jnzauth']?.getAccessToken()}`;
  }

  //   await checkJNZAuthHeder();
  const amountItem = array.length - 1;

  const multiPutFunction = new Promise((resolve, reject) => {
    array.forEach((element, index) => {
      const request = axios({
        url: `${url}`,
        method: 'PUT',
        headers: headers,
        data: element,
        timeout: timeout,
        dataType: 'json',
      });
      request
        .then((response) => {
          /*console.log("[API] Multi PUT : ", response, "product ::", element);*/

          if (array) {
            if (index === amountItem) resolve(response.data);
          } else {
            reject();
          }
        })
        .catch((error) => {
          console.error('[API] PUT Failure', error);
          reject(error);
        });
    });
  });

  // console.log("api log ==>",tempResponse)
  return multiPutFunction
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('[API] DELETE Failure', error.data);
      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_MULTIPLE_REMOVE_CART = async ({ url, data, array, token, admin_token, type }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  if (isClient && !Boolean(headers['Authorization'])) {
    headers['Authorization'] = `Bearer ${window['jnzauth']?.getAccessToken()}`;
  }

  //   await checkJNZAuthHeder();

  const multiPutFunction = new Promise((resolve, reject) => {
    array.forEach((element) => {
      const request = axios({
        url: `${url}`,
        method: 'PATCH',
        headers: headers,
        data: element,
        timeout: timeout,
        dataType: 'json',
      });
      request
        .then((response) => {
          /*console.log("[API] Multi PATCH : ", response, "id", element);*/
        })
        .catch((error) => {
          console.error('[API] PATCH Failure', error);
          reject(error);
        });
    }, resolve());
  });

  return multiPutFunction
    .then(() => {
      return { data: {}, msg: 'success' };
    })
    .catch((error) => {
      console.error('[API] DELETE Failure', error);

      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_MULTIPLE_POST = async ({ url, data, array, token, admin_token }) => {

  if (token)
    headers['x-auth-signature'] = token;
  if (admin_token)
    headers['x-auth-admin-signature'] = admin_token;

  await checkJNZAuthHeder();

  const multiDeleteFunction = new Promise((resolve, reject) => {
    array.forEach((element) => {
      data.name = element.name;
      data.code = element.code;
      const request = axios({
        url: `${url}/${element.uuid}/map`,
        method: 'POST',
        headers: headers,
        data: data,
        timeout: timeout,
        dataType: 'json',
      });
      request
        .then((response) => {
          /*console.log("[API] POST : ", response, "id", element);*/
        })
        .catch((error) => {
          console.error('[API] POST Failure', error);
          reject(error);
        });
    }, resolve());
  });

  return multiDeleteFunction
    .then(() => {
      return 'success';
    })
    .catch((error) => {
      console.error('[API] DELETE Failure', error);

      claerJNZAuthExpiredToken(errorHandler(error));
      return error;
    });
};

const method_IMPORT = async ({ url, data, token, admin_token, upload = false }) => {

  if (token)
    headers['x-auth-signature'] = token;
  else
    delete headers['x-auth-signature'];

  if (admin_token)
    headers['x-auth-signature'] = admin_token;
  else
    delete headers['x-auth-admin-signature'];

  if (upload)
    headers['Content-Type'] = 'multipart/form-data';

  await checkJNZAuthHeder();

  // console.log("[API] POST : ", data, url);

  const request = axios({
    url: url,
    method: 'POST',
    headers: headers,
    data: data,
    timeout: timeout,
    dataType: 'json',
  });

  return await request
    .then((response) => {
      // console.log("[API] POST : ", { response });
      return successHandler(response);
    })
    .catch((error) => {
      console.error('[API] POST Failure', { error });

      claerJNZAuthExpiredToken(errorHandler(error));
      return errorHandler(error);
    });
};

function successHandler(_result = {}) {

  const { status, data: innerData } = _result;
  const { code, msg, data, message, result } = (innerData || {});

  return {
    success: true,
    data: (data || innerData),
    status: status,
    code: code,
    msg: (message || msg),
    result
  };
}

function errorHandler(e) {
  const { response, message } = e;

  console.error('errorHandler : ', { response });

  return {
    error: {
      success: false,
      status: response?.status,
      data: response?.data,
      err: message,
    },
  };
}

//#region checkJNZAuthHeder ===============================================================================================

const checkJNZAuthHeder = async (isClear) => {

  if (isClient && !Boolean(headers['Authorization'])) {
    // let _token = isClear ? window['jnzauth']?.getAccessToken() : "dsadfasdfasdfsaf";

    let _token = window['jnzauth']?.getAccessToken();

    // console.log('checkJNZAuthHeder : ', { isClear, _token })

    if (!Boolean(_token)) {
      await window['jnzauth'].refeshToken().then((token) => {
        _token = token?.a_tkn;
      });
    }

    headers['Authorization'] = `Bearer ${_token}`;
    headers['x-company'] = window['jnzauth']?.getCompanyToken();
  }
};

const claerJNZAuthExpiredToken = async ({ error }) => {
  const { code } = error?.data || {};

  if (code === 401 || code == '401') {
    if (isClient && Boolean(headers['Authorization'])) {
      headers['Authorization'] = undefined;
      await checkJNZAuthHeder(true);
    }
  }
};

//#endregion checkJNZAuthHeder ============================================================================================

export default {
  method_GET,
  method_GET_GEO,
  method_POST,
  method_PUT,
  method_PATCH,
  method_DELETE,
  method_MULTIPLE_DELETE,
  method_MULTIPLE_PATCH,
  method_MULTIPLE_PUT,
  method_MULTIPLE_EDIT_CART,
  method_MULTIPLE_REMOVE_CART,
  method_MULTIPLE_POST,
  method_IMPORT,
  method_GET_MULTIPLE_HEADER,
  method_POST_MULTIPLE_HEADER
};
